import React from "react"
import { useMantineTheme } from "@mantine/core"

import { Icon } from "@/components"

export const ErrorIcon = () => {
    const theme = useMantineTheme()

    return <Icon icon="times" color={theme.colors.red[5]} />
}
